import { Heap } from "./Heap";

export class PriorityQueue<T> {

    private heap: Heap<T>;

    constructor(descending: boolean) {
        this.heap = new Heap<T>(!descending, 1024);
    }

    public dequeue(): T {
        let node = this.heap.pop();
        if (node) {
            return node.element;
        } else {
            return null;
        }
    }

    public peek(): T {
        let node = this.heap.peek();
        if (node) {
            return node.element;
        } else {
            return null;
        }
    }

    public enqueue(element: T, priority: number): void {
        this.heap.insert(element, priority);
    }

    public get size() {
        return this.heap.length;
    }

    public get isEmpty() {
        return this.heap.isEmpty();
    }

}